module.exports = __webpack_public_path__ + "static/media/Circo2025_05.d263899a.webp";